import tokens from './tokens'
import { FarmConfig } from './types'

const farms: FarmConfig[] = [
  {
    farmName: 'Feeling Loved',
    image: 'heart_eyes',
    pid: 0,
    lpSymbol: 'BHC',
    lpAddresses: {
      250: '0x7BEB05cf5681f402E762F8569c2Fc138a2172978',
    },
    token: tokens.wftm,
    quoteToken: tokens.wftm,
    farmAddress: '0x28d1f6698c20802b8c38ae83903046f61e60f529',
    earn: 'FTM',
    buyURL: 'https://fantom-exchange.jetswap.finance/#/swap?inputCurrency=0x7beb05cf5681f402e762f8569c2fc138a2172978',
    dualEarn: false,
    factor: 0,
    ended: true,
    isBNB: true,
    info: '#',
    start: 'Coming soon!',
    category: 'emotional',
  },
  {
    farmName: 'Feeling Happy',
    image: 'happy_emoji',
    pid: 1,
    lpSymbol: 'BHC',
    lpAddresses: {
      250: '0x7BEB05cf5681f402E762F8569c2Fc138a2172978',
    },
    token: tokens.bhc,
    quoteToken: tokens.wftm,
    farmAddress: '0x5Dd5F08052C44AdA503415b91997cE187046F6A5',
    earn: 'BHC',
    buyURL: 'https://fantom-exchange.jetswap.finance/#/swap?inputCurrency=0x7beb05cf5681f402e762f8569c2fc138a2172978',
    dualEarn: false,
    factor: 0,
    ended: true,
    isBNB: false,
    info: '#',
    start: 'Coming soon!',
    category: 'emotional',
  },
  {
    farmName: 'Feeling Cute',
    image: 'wink_emoji',
    pid: 2,
    lpSymbol: 'HPS',
    lpAddresses: {
      250: '0xAC1F25AEE575D35C668B0a4D336f20E3e92adCd2',
    },
    token: tokens.hps,
    quoteToken: tokens.wftm,
    farmAddress: '0xd097d943B86d108b023b5B2658b2f8990808800C',
    earn: 'HPS',
    buyURL: 'https://swap.spiritswap.finance/#/swap/0x5Cc61A78F164885776AA610fb0FE1257df78E59B',
    dualEarn: false,
    factor: 0,
    ended: true,
    isBNB: false,
    info: '#',
    start: 'Coming soon!',
    category: 'emotional',
  },
  {
    farmName: 'Feeling Awesome',
    image: '3_grande',
    pid: 3,
    lpSymbol: 'HPS',
    lpAddresses: {
      250: '0xAC1F25AEE575D35C668B0a4D336f20E3e92adCd2',
    },
    token: tokens.wftm,
    quoteToken: tokens.wftm,
    // farmAddress: '0x2D9Cf8B37B4d377B62D08a23089233820d5441Da',
    farmAddress: '0x686f2BbcDcc2dc0d898bbB5e9Ec4bB89d4846EB8',
    earn: 'FTM',
    buyURL: 'https://swap.spiritswap.finance/#/swap/0x5Cc61A78F164885776AA610fb0FE1257df78E59B',
    dualEarn: false,
    factor: 0,
    ended: true,
    isBNB: true,
    info: '#',
    start: 'Coming soon!',
    category: 'emotional',
  },
  {
    farmName: 'Feeling Good',
    image: 'smile_holo',
    pid: 4,
    lpSymbol: 'BHC-FTM JetSwap LP',
    lpAddresses: {
      250: '0x20951B5cEC16815FE160e7a1453a94912AfD31B2',
    },
    token: tokens.bhc,
    quoteToken: tokens.wftm,
    farmAddress: '0xe3891B87204870FC26dE020fc9d92eA9848Df74f',
    earn: 'BHC',
    buyURL: 'https://fantom-exchange.jetswap.finance/#/add/0x7beb05cf5681f402e762f8569c2fc138a2172978/ETH',
    dualEarn: false,
    factor: 0,
    ended: false,
    isBNB: false,
    info: '#',
    start: 'Coming soon!',
    category: 'farming',
  },
  {
    farmName: 'Feeling Inspirited',
    image: 'ghost',
    pid: 5,
    lpSymbol: 'HPS-FTM SpiritSwap LP',
    lpAddresses: {
      250: '0xa42DE2C3847b96894D44E8A8258A838FAaD9dD5f',
    },
    token: tokens.hps,
    quoteToken: tokens.wftm,
    farmAddress: '0x554Ef451793a187A89CF8063e274A2b2E24A21f9',
    earn: 'HPS',
    buyURL: 'https://swap.spiritswap.finance/#/add/0xac1f25aee575d35c668b0a4d336f20e3e92adcd2/FTM',
    dualEarn: false,
    factor: 0,
    ended: false,
    isBNB: false,
    info: '#',
    start: 'Coming soon!',
    category: 'farming',
  },
]

export default farms
